import { useMutation } from "@tanstack/react-query";

import { trialRunMeterUpload } from "@services/bulkMeterUpload";
import type { MeterUploadRowData } from "@utils/bulkMeterUpload/buildTrialRunRow";

type TrialRunInput = {
  level1ResourceId: string;
  bulkMeterReadings: MeterUploadRowData[];
};

export const useTrialRunMeterUpload = (
  options: Record<string, any> = {},
) =>
  useMutation((input: TrialRunInput) => trialRunMeterUpload(input), {
    ...options,
  });
